module.exports = __webpack_public_path__ + "img/INTERIOR-IGNIS-2021-7-2.26fb2fbd.jpg";